import { Event } from "types";
import create from "zustand";

export interface UnassignGuidePromptStore {
    event: Event | null;
    onSettled: (() => void) | null;
    hostIds: string[];
    open: (event: Event, onSettled?: () => void) => void;
    close: () => void;
    claimHost: (hostId: string) => void;
    releaseHost: (hostId: string) => void;
}

export const useUnassignGuidePromptStore = create<UnassignGuidePromptStore>((set, get) => ({
    event: null,
    onSettled: null,
    hostIds: [],

    open: (event: Event, onSettled?: () => void) => set({ event, onSettled: onSettled ?? null }),

    close: () => {
        const { onSettled } = get();
        set({ event: null, onSettled: null });
        onSettled?.();
    },

    claimHost: (hostId: string) => set((state) => ({ hostIds: [...state.hostIds, hostId] })),

    releaseHost: (hostId: string) => set((state) => ({ hostIds: state.hostIds.filter((id) => id !== hostId) })),
}));
